import {
    GET_WISHLIST,
    GET_WISHLIST_PRODUCTS,
    WISHLIST_LOADING,
} from "../actions/types";
import Axios from "axios";

export const getWishList = () => (dispatch) => {
    Axios.get("/api/users/wishlist")
        .then((res) => {
            console.log(res.data, "wish ");
            dispatch({
                type: GET_WISHLIST,
                payload: res.data[0],
            });
            dispatch(getCartProducts(res.data[0].wishlist));
            //    console.log(res.data[0].saves);
            // dispatch(refreshSaved(JSON.stringify(res.data[0].saves)));
        })
        .catch((err) => {
            // dispatch({
            //     type: GET_ERRORS,
            //     payload: err.response.data,
            // });
        });
};

export const getCartProducts = (cart) => (dispatch) => {
    dispatch(setCartLoading());
    Axios.get(`/api/posts/wishlist/${JSON.stringify(cart)}`)
        .then((res) => {
            dispatch({
                type: GET_WISHLIST_PRODUCTS,
                payload: res.data,
            });
            dispatch(setCartLoading());
        })
        .catch((err) => {
            console.log(err.response, "crter");
            dispatch(setCartLoading());
        });
};

export const addWishlist = (id) => (dispatch) => {
    Axios.post("/api/posts/addtowishlist", { postid: id })
        .then((res) => {
            dispatch(getWishList());
            window.location.href = "/wishlist";
            //    console.log(res.data[0].saves);
            // dispatch(refreshSaved(JSON.stringify(res.data[0].saves)));
        })
        .catch((err) => {
            // dispatch({
            //     type: GET_ERRORS,
            //     payload: err.response.data,
            // });
            console.log(err.response);
        });
};

export const removeWishlist = (id) => (dispatch) => {
    Axios.post("/api/posts/removewishlist", { postid: id })
        .then((res) => {
            console.log("removesuces");
            dispatch(getWishList());
            //    console.log(res.data[0].saves);
            // dispatch(refreshSaved(JSON.stringify(res.data[0].saves)));
        })
        .catch((err) => {
            // dispatch({
            //     type: GET_ERRORS,
            //     payload: err.response.data,
            // });
            console.log(err.response);
        });
};

export const setCartLoading = () => {
    return {
        type: WISHLIST_LOADING,
    };
};
